module.exports = __webpack_public_path__ + "img/milestone_png.ec6ae7a7.png";